'use client';

import { Padding, Typography } from '@musinsa/mds';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';

type ActivityCardProps = {
  imageSrc: string;
  title: string;
  subText?: string;
  className?: string;
};

export const ActivityCard = ({ imageSrc, title, subText, className }: ActivityCardProps) => (
  <Padding className={twMerge('flex flex-col', className)}>
    <Padding bottom="2" x="4" className="flex flex-col">
      <Typography variant="textEtc16Med" className="pb-2">
        {title}
      </Typography>
      {subText && <Typography variant="body14pxReg">{subText}</Typography>}
    </Padding>

    <div className="bg-white px-4 py-1 w-full">
      <Image
        src={imageSrc}
        alt={title}
        width={0}
        height={0}
        sizes="100vw"
        unoptimized
        className="w-full h-auto object-cover rounded"
      />
    </div>
  </Padding>
);
